import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeChatCustomActionModal } from '../../actions/chatCustomActionModal';
import { ChatActionModal } from '../../components/ChatActionModal';
import { useCompanionData } from '../../hooks';
import { chatCustomActionModalSelector } from '../../selectors/chatCustomActionModalSelector';
import { sendCustomActions } from '../../services/sendCustomActions';

export const CustomActionModalContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const { isOpened, chatId, action, cancelButtonText, confirmButtonText, text } =
    useSelector(chatCustomActionModalSelector);
  const { companionId } = useCompanionData(chatId);

  const onCloseHandler = React.useCallback(() => dispatch(closeChatCustomActionModal()), [dispatch]);
  const onConfirmHandler = React.useCallback(() => {
    if (chatId && action) {
      dispatch(sendCustomActions({ chatId, action, companionId }));
    }
    dispatch(closeChatCustomActionModal());
  }, [action, chatId, companionId, dispatch]);

  if (!isOpened) {
    return null;
  }

  return (
    <ChatActionModal
      cancelButtonText={cancelButtonText}
      buttonText={confirmButtonText}
      onCancel={onCloseHandler}
      onConfirm={onConfirmHandler}
      text={text}
    />
  );
};
